import React, { useState, useEffect } from "react";
import { useNavigate, } from "react-router-dom";
import profileimg from "../../assets/profileimg.png";
import "../../userprofile.css";
import { uploadImage } from "../../utils/helpers/fileupload";
import { userUploadAadhaar } from "../../store/slices/register";
import { useSelector, useDispatch } from "react-redux";
import { getProfile, getPrivacy, editPrivacy, getRecentActivity } from "../../store/slices/profile";
import { Container } from "react-bootstrap";
import { getPreferredMatches } from "../../store/slices/preference";



let _addToast = null;

export function toast(msg, type = "info") {
  _addToast && _addToast(msg, type);
}

function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    _addToast = (msg, type) => {
      const id = Date.now();
      setToasts((prev) => [...prev, { id, msg, type }]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 3500);
    };
    return () => {
      _addToast = null;
    };
  }, []);

  const icons = { success: "✓", error: "✕", info: "ℹ", loading: "⏳" };
  const colors = {
    success: { bg: "#e8f5e8", border: "#4caf50", icon: "#4caf50" },
    error: { bg: "#fde8e8", border: "#e53935", icon: "#e53935" },
    info: { bg: "#e8f0fd", border: "#1976d2", icon: "#1976d2" },
    loading: { bg: "#fdf6e8", border: "#f59e0b", icon: "#f59e0b" },
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 20,
        right: 20,
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      {toasts.map((t) => {
        const c = colors[t.type] || colors.info;
        return (
          <div
            key={t.id}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              background: c.bg,
              border: `1.5px solid ${c.border}`,
              borderRadius: 10,
              padding: "12px 18px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
              minWidth: 260,
              maxWidth: 360,
              animation: "slideIn 0.3s ease",
            }}
          >
            <span
              style={{
                width: 26,
                height: 26,
                borderRadius: "50%",
                background: c.icon,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                fontWeight: 700,
                flexShrink: 0,
              }}
            >
              {icons[t.type]}
            </span>
            <span style={{ fontSize: 13.5, color: "#333", lineHeight: 1.4 }}>
              {t.msg}
            </span>
          </div>
        );
      })}
      <style>{`
        @keyframes slideIn {
          from { opacity: 0; transform: translateX(40px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  );
}

function ProfileReviewBanner({ onLearnMore }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <>
      {visible && (
        <Container>
          <div className="review-banner">
            <span className="review-banner-icon">🔍</span>

            <span className="review-banner-text">
              <span className="text-full">
                <strong>Profile Under Review</strong> — Your profile is
                undergoing a quality and authenticity check. Full access will be
                unlocked once verification is completed.
              </span>
              <span className="text-short">
                <strong>Under Review</strong> — Verification in progress.
              </span>
            </span>
          </div>
        </Container>
      )}
    </>
  );
}



const matchNav = [
  { id: "inbox", icon: "📥", label: "Inbox", count: null, path: "/user/message" },
  { id: "accepted", icon: "✓", label: "Accepted", count: null, path: "/user/interests" },
  { id: "interested", icon: "👥", label: "Interested", count: null, path: "/user/interests" },
  { id: "shortlisted", icon: "☆", label: "Shortlisted", count: null, path: "/user/shortlist" },
  {
    id: "sent",
    icon: "➤",
    label: "Sent Requests",
    count: null,
    path: "/user/sent-requests",
  },
];

const accountNav = [
  { icon: "⊘", label: "Blocked Members", path: "/user/interests" },
  { icon: "✕", label: "Declined / Cancelled", path: "/user/interests" },
];

function fmtSize(bytes) {
  if (bytes < 1024) return bytes + " B";
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
  return (bytes / (1024 * 1024)).toFixed(2) + " MB";
}

function UploadModal({ onDone, dispatch }) {
  const [photoDrag, setPhotoDrag] = useState(false);
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);

  const loadPreview = (file, cb) => {
    const reader = new FileReader();
    reader.onload = (e) => cb(e.target.result);
    reader.readAsDataURL(file);
  };

  const validatePhoto = (file) => {
    if (!file) return false;
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      toast("Only JPG or PNG images are allowed", "error");
      return false;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast("Image size must be less than 5 MB", "error");
      return false;
    }
    if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png)$/)) {
      toast("Invalid image format", "error");
      return false;
    }
    return true;
  };


  const getErrMsg = (err, fallback) =>
    err?.message || (typeof err === "string" ? err : null) || fallback;


  const handlePhoto = (file) => {
    if (!validatePhoto(file)) return;
    setPhotoFile(file);
    loadPreview(file, setPhotoPreview);
  };

  const handleUploadPhoto = async () => {
    if (!photoFile) return;

    try {
      setUploading(true);

      const accessToken = localStorage.getItem("accessToken");

      if (!accessToken) {
        toast("Access token not found. Please login again.", "error");
        return;
      }

      console.log("ACCESS TOKEN:", accessToken);

      const profilePhoto = await uploadImage(
        photoFile,
        accessToken
      );

      const result = await dispatch(
        userUploadAadhaar({
          profilePhoto,
        })
      ).unwrap();

      await dispatch(getProfile()).unwrap();

      toast(
        result?.message || "Profile photo uploaded successfully",
        "success"
      );

      onDone();
    } catch (err) {
      toast(getErrMsg(err, "Upload failed"), "error");
    } finally {
      setUploading(false);
    }
  };



  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <span className="modal-header-decor">✦</span>

          <div className="modal-step-pills">
            <div className="modal-pill active" />
          </div>
          <div className="modal-title">
            Upload Profile Photo
          </div>

        </div>


        <>
          <div className="modal-body">
            <div
              className={`drop-zone${photoDrag ? " drag-over" : ""}`}
              onDragOver={(e) => {
                e.preventDefault();
                setPhotoDrag(true);
              }}
              onDragLeave={() => setPhotoDrag(false)}
              onDrop={(e) => {
                e.preventDefault();
                setPhotoDrag(false);
                handlePhoto(e.dataTransfer.files[0]);
              }}
            >
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handlePhoto(e.target.files[0])}
              />
              <div className="drop-icon" style={{ background: "#fde8f0" }}>
                📷
              </div>
              <div className="drop-title">
                {photoDrag
                  ? "Drop your photo here"
                  : "Drag & drop your photo"}
              </div>
              <div className="drop-sub">
                or click to browse from your device
              </div>
              <div className="drop-formats">
                JPG, PNG · Max 5 MB · Min 200 × 200 px
              </div>
            </div>
            {photoFile && (
              <div className="file-preview">
                {photoPreview ? (
                  <img
                    src={photoPreview}
                    alt="preview"
                    className="preview-thumb"
                  />
                ) : (
                  <div className="preview-thumb-doc">📷</div>
                )}
                <div className="preview-info">
                  <div className="preview-name">{photoFile.name}</div>
                  <div className="preview-size">
                    {fmtSize(photoFile.size)}
                  </div>
                  <div className="preview-status">✓ Ready to upload</div>
                </div>
                <button
                  className="preview-remove"
                  onClick={() => {
                    setPhotoFile(null);
                    setPhotoPreview(null);
                  }}
                >
                  ✕
                </button>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              className="modal-btn-next"
              disabled={!photoFile || uploading}
              onClick={handleUploadPhoto}
            >
              {uploading ? "Uploading..." : "Upload Photo"}
            </button>
          </div>
        </>




      </div>
    </div>
  );
}

export default function UserDashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [privacy, setPrivacy] = useState({
    profileVisibleTo: "Connections",
    connectionRequests: "Everyone",
    profileViews: "Connections",
    photoVisibility: "Connections",
  });

  const {
    profilelist = {},
    privacy: privacyData = {},
    activity = [],
    loading,
  } = useSelector((state) => state.profile);

  const {
    preferredMatches = [],
    preferredLoading,
  } = useSelector((state) => state.preference);

  useEffect(() => {
    dispatch(getProfile());
    dispatch(getRecentActivity());
    dispatch(getPreferredMatches({ page: 1, limit: 3 }));
    dispatch(getPrivacy()).then((res) => {
      if (res.payload?.data) {
        setPrivacy(res.payload.data);
      }
    });
  }, [dispatch]);

  const userName = profilelist?.name || "";
  const status = profilelist?.status;
  const completionPercent = profilelist?.profileCompletion;
  const hasActivePlan = profilelist?.hasActivePlan;
  const age = profilelist?.age;

  const height = profilelist?.profile?.height;
  const maritalStatus = profilelist?.profile?.maritalStatus;
  const motherTongue = profilelist?.profile?.motherTongue;

  const nativeDistrict = profilelist?.profile?.nativeDistrict;
  const subCaste = profilelist?.profile?.subCaste;

  const profilePhoto = profilelist?.profilePhoto || "";
  const isVerified =
    profilelist?.profileVerified === true ||
    profilelist?.profileVerified === "true";
  const firstLetter = userName?.charAt(0)?.toUpperCase();

  const [activeNav, setActiveNav] = useState(
    () => window.location.pathname || "/user/dashboard",
  );
  const [showModal, setShowModal] = useState(false);
  const [avatarSrc, setAvatarSrc] = useState(profileimg);

  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [showBuyPlanModal, setShowBuyPlanModal] = useState(false);

  const handleNavClick = (path) => {
    const allowedWithoutPlan = [
      "/user/home",
      "/user/membership",
    ];

    // Allow these pages without membership
    if (!hasActivePlan && !allowedWithoutPlan.includes(path)) {
      setShowBuyPlanModal(true);
      return;
    }

    // Block navigation if profile is under review
    if (status === "under review") {
      toast("Your profile is under review.", "error");
      return;
    }

    // Block navigation if verification is pending
    if (status === "pending") {
      toast("Please complete your profile verification.", "error");
      return;
    }

    setShowBuyPlanModal(false);
    setActiveNav(path);
    navigate(path);
  };

  const handleModalDone = (photoPreview) => {
    if (photoPreview) setAvatarSrc(photoPreview);
    setShowModal(false);
  };

  useEffect(() => {
    if (status === "pending") {
      setShowModal(true);
    }
  }, [status]);

  // Completion calculation

  const handlePrivacyChange = async (field, value) => {
    const updated = {
      ...privacy,
      [field]: value,
    };

    setPrivacy(updated);

    try {
      await dispatch(editPrivacy(updated)).unwrap();
      toast("Privacy settings updated successfully", "success");
    } catch (err) {
      toast("Failed to update privacy settings", "error");
    }
  };

  const activityIcons = {
    INTEREST_SENT: "💌",
    INTEREST_ACCEPTED: "✅",
    INTEREST_REJECTED: "❌",
    SHORTLISTED: "⭐",
    SHORTLIST_REMOVED: "🗑️",
  };

  const formatTime = (date) => {
    if (!date) return "";

    const diff = Math.floor((Date.now() - new Date(date)) / 1000);

    if (diff < 60) return "Just now";
    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)} hrs ago`;
    return `${Math.floor(diff / 86400)} days ago`;
  };
  return (
    <>
      <ToastContainer />

      {/* Upload Modal */}
      {showModal && (
        <UploadModal
          onClose={() => setShowModal(false)}
          onDone={handleModalDone}
          dispatch={dispatch}
        />
      )}

      {showReviewPopup && (
        <div
          className="modal-overlay"
          onClick={() => setShowReviewPopup(false)}
        >
          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: 420 }}
          >
            <div className="modal-header">
              <button
                className="modal-close"
                onClick={() => setShowReviewPopup(false)}
              >
                ✕
              </button>
              <div className="modal-title">Profile Under Review 🔍</div>
              <div className="modal-subtitle">
                Here's what's happening with your profile
              </div>
            </div>
            <div className="modal-body" style={{ padding: "20px 24px" }}>
              <p
                style={{
                  fontSize: 14,
                  color: "#555",
                  lineHeight: 1.7,
                  margin: 0,
                }}
              >
                Your profile is currently being reviewed by our team for quality
                and authenticity. This process typically takes{" "}
                <strong>24–48 hours</strong>.<br />
                <br />
                Once verified, you'll get full access to all features including
                messaging, viewing contact details and connecting with matches.
              </p>
            </div>
            <div className="modal-footer">
              <button
                className="modal-btn-next"
                style={{ width: "100%" }}
                onClick={() => setShowReviewPopup(false)}
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {status === "under review" && (
        <ProfileReviewBanner onLearnMore={() => setShowReviewPopup(true)} />
      )}

      <div className="dash-root">
        <div className="dash-grid">
          <div className="sidebar">
            {/* Profile Card */}
            {loading ? (
              <div className="profile-card-userprofile glow-gradient ep-skeleton-card ">
                <div className="avatar-wrap">
                  <div
                    className="ep-skeleton-avatar"
                    style={{ margin: "0 auto" }}
                  />
                </div>
                <div
                  className="ep-skeleton-title"
                  style={{ margin: "12px auto 8px", width: "60%" }}
                />
                <div
                  className="ep-skeleton-line short"
                  style={{ margin: "0 auto", width: "50%" }}
                />
                <div style={{ marginTop: 16 }}>
                  <div
                    className="ep-skeleton-line"
                    style={{ marginBottom: 6 }}
                  />
                  <div className="ep-skeleton-line short" />
                </div>
              </div>
            ) : (
              <div className="profile-card-userprofile glow-gradient ">
                <div className="avatar-wrap">
                  <div className="avatar">
                    {profilePhoto ? (
                      <img src={profilePhoto} alt="avatar" />
                    ) : (
                      firstLetter
                    )}
                  </div>
                </div>
                <div className="profile-name">{userName}</div>
                <span className="badge-premium">
                  {isVerified ? "✔ Profile Verified" : "⚠ Not Verified"}
                </span>
                <div className="profile-completeness">
                  <div className="comp-label">
                    <span>Profile Completeness</span>
                    <span>{completionPercent}%</span>
                  </div>
                  <div className="comp-bar">
                    <div
                      className="comp-fill"
                      style={{ width: `${completionPercent}%` }}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="nav-box">
              <div className="nav-box-title">Matches</div>
              {matchNav.map((item) => {
                const locked = !hasActivePlan || status === "under review";
                return (
                  <button

                    key={item?.id}
                    className={`nav-item${activeNav === item.path ? " active" : ""}${locked ? " nav-item-locked" : ""}`}
                    onClick={() => handleNavClick(item.path)}
                    title={locked ? "Verify profile to access" : ""}
                  >
                    <div className="nav-icon">{item?.icon}</div>
                    {item?.label}
                    {item?.count && !locked && (
                      <span className="nav-count">{item?.count}</span>
                    )}
                    {locked && (
                      <span style={{ marginLeft: "auto", fontSize: 11 }}>
                        🔒
                      </span>
                    )}
                  </button>
                );
              })}
            </div>

            <div className="nav-box">
              <div className="nav-box-title">Account</div>
              {accountNav.map((item) => {
                const locked = !hasActivePlan || status === "under review";
                return (
                  <button
                    key={item?.path}
                    className={`nav-item${activeNav === item.path ? " active" : ""}${locked ? " nav-item-locked" : ""}`}
                    onClick={() => handleNavClick(item.path)}
                    title={locked ? "Verify profile to access" : ""}
                  >
                    <div className="nav-icon">{item?.icon}</div>
                    {item?.label}
                    {locked && (
                      <span style={{ marginLeft: "auto", fontSize: 11 }}>
                        🔒
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="main">
            {loading ? (
              <div className="hero-banner glow-gradient ep-skeleton-card">
                <div className="hero-left">
                  <div
                    className="ep-skeleton-title"
                    style={{ width: "60%", marginBottom: 10 }}
                  />
                  <div
                    className="ep-skeleton-line"
                    style={{ marginBottom: 6 }}
                  />
                  <div
                    className="ep-skeleton-line short"
                    style={{ marginBottom: 16 }}
                  />
                  <div
                    className="ep-skeleton-line"
                    style={{ width: 140, height: 36, borderRadius: 8 }}
                  />
                </div>
                <div className="hero-stats">
                  {[1, 2, 3].map((i, idx, arr) => (
                    <React.Fragment key={i}>
                      <div className="stat-item">
                        <div
                          className="ep-skeleton-title"
                          style={{ width: 40, marginBottom: 6 }}
                        />
                        <div
                          className="ep-skeleton-line short"
                          style={{ width: 70 }}
                        />
                      </div>
                      {idx < arr.length - 1 && <div className="stat-divider" />}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ) : (
              <div className="hero-banner glow-gradient ">
                <div className="hero-left">
                  <div className="hero-title">Your Perfect Match Awaits ✦</div>
                  <div className="hero-sub">
                    Explore matches based on your preferences and connect
                    instantly.
                  </div>
                  <button
                    className="hero-cta"
                    onClick={() => handleNavClick("/user/profile-search")}
                  >
                    VIEW MATCHES →
                  </button>
                </div>
                <div className="hero-stats">
                  {[
                    ["0", "Profile Views"],
                    ["0", "New Matches"],
                    ["0", "Messages"],
                  ].map(([num, label], i, arr) => (
                    <React.Fragment key={label}>
                      <div className="stat-item">
                        <span className="stat-num">{num}</span>
                        <div className="stat-label">{label}</div>
                      </div>
                      {i < arr.length - 1 && <div className="stat-divider" />}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            )}

            <div className="actions-row">
              {[
                {
                  label: "✦ Daily Recommendations",
                  to: "/user/recommendations",
                },
                { label: "🔍 Search Profiles", to: "/user/profile-search" },
                { label: "⊕ Edit Profile", to: "/user/edit-profile" },
                { label: "🖼️ Photos", to: "/user/galleryupload" },
              ].map(({ label, to }) => (
                <button
                  key={label}
                  className="action-chip"
                  style={{
                    textDecoration: "none",
                    border: "none",
                    background: "none",
                  }}
                  onClick={() => handleNavClick(to)}
                >
                  {label}
                </button>
              ))}
            </div>

            {/* Two Col - Profile Info + Privacy */}
            <div className="two-col">
              {/* Profile Information */}
              <div className="card cool-glow-card">
                <div className="card-header">
                  <div className="card-title">Profile Information</div>
                  <button
                    className="card-link"
                    onClick={() => navigate("/user/edit-profile")}
                  >
                    Edit →
                  </button>
                </div>
                {loading ? (
                  <div className="info-grid">
                    {[1, 2, 3, 4, 5, 6].map((i) => (
                      <div key={i} className="info-item">
                        <div
                          className="ep-skeleton-line short"
                          style={{ width: 70, marginBottom: 6 }}
                        />
                        <div
                          className="ep-skeleton-line"
                          style={{ width: 100 }}
                        />
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="info-grid">
                    {[
                      ["Age", age ? `${age} years` : "—"],
                      ["Height", height],
                      [
                        "Native District",
                        nativeDistrict ? nativeDistrict : "—",
                      ],
                      ["Marital Status", maritalStatus ? maritalStatus : "—"],
                      ["Subcaste", subCaste ? subCaste : "—"],
                      ["Mother Tongue", motherTongue ? motherTongue : "—"],
                    ].map(([label, val]) => (
                      <div key={label} className="info-item">
                        <div className="info-label">{label}</div>
                        <div className="info-val">{val}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Privacy Settings */}
              <div className="card cool-glow-card">
                <div className="card-header">
                  <div className="card-title">Privacy Settings</div>
                </div>
                {loading ? (
                  [1, 2, 3, 4].map((i) => (
                    <div key={i} className="priv-row">
                      <div
                        className="ep-skeleton-line short"
                        style={{ width: 120 }}
                      />
                      <div
                        className="ep-skeleton-line"
                        style={{ width: 100, height: 28, borderRadius: 6 }}
                      />
                    </div>
                  ))
                ) : (
                  [
                    {
                      label: "Profile Visible To",
                      field: "profileVisibleTo",
                      options: ["Everyone", "Verified Members"],
                    },
                    {
                      label: "Connection Requests",
                      field: "connectionRequests",
                      options: [
                        "Everyone",
                        "Verified Members",

                      ],
                    },
                    {
                      label: "Profile Views",
                      field: "profileViews",
                      options: ["Everyone", "Verified Members",],
                    },
                    {
                      label: "Photo Visibility",
                      field: "photoVisibility",
                      options: [
                        "Everyone",
                        "Request Required",
                      ],
                    },
                  ].map(({ label, field, options }) => (
                    <div key={field} className="priv-row">
                      <div className="priv-label">{label}</div>

                      <select
                        className="priv-select"
                        value={privacy?.[field] || ""}
                        onChange={(e) =>
                          handlePrivacyChange(field, e.target.value)
                        }
                      >
                        {(options || []).map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* Two Col - Recent Matches + Recent Activity */}
            <div className="two-col">
              {/* Recent Matches */}
              <div className="card cool-glow-card">
                <div className="card-header">
                  <div className="card-title">Preferred Matches</div>
                  <button
                    className="card-link"
                    onClick={() => navigate("/user/recommendations")}
                  >
                    View all →
                  </button>
                </div>
                <div className="match-list">
                  {preferredLoading ? (
                    [1, 2, 3].map((i) => (
                      <div key={i} className="match-row">
                        <div
                          className="ep-skeleton-circle"
                          style={{ width: 44, height: 44 }}
                        />
                        <div className="match-info" style={{ flex: 1 }}>
                          <div
                            className="ep-skeleton-title"
                            style={{ marginBottom: 6 }}
                          />
                          <div className="ep-skeleton-line short" />
                        </div>
                      </div>
                    ))
                  ) : preferredMatches.length === 0 ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: 25,
                        color: "#888",
                      }}
                    >
                      No preferred matches found.
                    </div>
                  ) : (
                    preferredMatches.map((item) => (
                      <div key={item._id} className="match-row">
                        <div className="match-avatar">
                          {item.profilePhoto ? (
                            <img
                              src={item.profilePhoto}
                              alt={item.name}
                              style={{
                                width: 44,
                                height: 44,
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            item.name?.charAt(0)
                          )}
                        </div>

                        <div className="match-info" onClick={() =>
                          navigate(`/user/profile-details/${item._id}`)
                        }>
                          <div className="match-name">{item.name}</div>

                          <div className="match-meta">
                            {item.age} yrs
                            {item.profile?.height
                              ? ` • ${item.profile.height}`
                              : ""}
                            {item.profile?.nativeDistrict
                              ? ` • ${item.profile.nativeDistrict}`
                              : ""}
                          </div>
                        </div>


                      </div>
                    ))
                  )}
                </div>
              </div>

              {/* Recent Activity */}
              <div className="card cool-glow-card">
                <div className="card-header">
                  <div className="card-title">Recent Activity</div>
                </div>
                <div className="timeline">
                  {loading ? (
                    [1, 2, 3].map((i) => (
                      <div key={i} className="tl-item ep-skeleton-card">
                        <div
                          className="ep-skeleton-circle"
                          style={{ width: 36, height: 36 }}
                        />
                        <div className="tl-content" style={{ flex: 1 }}>
                          <div className="ep-skeleton-line" style={{ marginBottom: 6 }} />
                          <div
                            className="ep-skeleton-line short"
                            style={{ width: 80 }}
                          />
                        </div>
                      </div>
                    ))
                  ) : activity.length === 0 ? (
                    <div
                      style={{
                        padding: 25,
                        textAlign: "center",
                        color: "#888",
                      }}
                    >
                      No recent activity found.
                    </div>
                  ) : (
                    activity.map((item) => {
                      const currentUserId = profilelist?._id;

                      const isSender = item.fromUser?._id === currentUserId;

                      const otherUser = isSender ? item.toUser : item.fromUser;

                      let message = "";

                      switch (item.type) {
                        case "INTEREST_SENT":
                          message = isSender
                            ? `You sent an interest to ${otherUser?.name}`
                            : `${otherUser?.name} sent you an interest`;
                          break;

                        case "INTEREST_ACCEPTED":
                          message = isSender
                            ? `${otherUser?.name} accepted your interest`
                            : `You accepted ${otherUser?.name}'s interest`;
                          break;

                        case "INTEREST_REJECTED":
                          message = isSender
                            ? `${otherUser?.name} rejected your interest`
                            : `You rejected ${otherUser?.name}'s interest`;
                          break;

                        case "SHORTLISTED":
                          message = isSender
                            ? `You shortlisted ${otherUser?.name}`
                            : `${otherUser?.name} shortlisted you`;
                          break;

                        case "SHORTLIST_REMOVED":
                          message = isSender
                            ? `You removed ${otherUser?.name} from shortlist`
                            : `${otherUser?.name} removed you from shortlist`;
                          break;

                        default:
                          message = "Activity";
                      }

                      return (
                        <div key={item._id} className="tl-item">
                          <div className="tl-dot">
                            {activityIcons[item.type] || "📌"}
                          </div>

                          <div className="tl-content">
                            <div className="tl-title">{message}</div>

                            <div className="tl-time">
                              {formatTime(item.createdAt)}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showBuyPlanModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowBuyPlanModal(false)} //  close on outside click
        >
          <div
            className="modal-box"
            style={{ maxWidth: 400 }}
            onClick={(e) => e.stopPropagation()} //  prevent inside click closing
          >
            <div className="modal-header">
              <div className="modal-title">Upgrade Required</div>
            </div >

            <div className="modal-body" style={{ padding: 20 }}>
              <p style={{ fontSize: 14, color: "#555" }}>
                You need an active membership plan to access this feature.
              </p>
            </div>

            <div className="modal-footer">
              <button
                className="modal-btn-next"
                style={{ width: "100%" }}
                onClick={() => {
                  setShowBuyPlanModal(false);
                  navigate("/user/membership");
                }}
              >
                Buy Plan →
              </button>
            </div>
          </div >
        </div >
      )
      }

    </>
  );
}
